module.exports = __webpack_public_path__ + "img/m2g-icon-only.5b5b8d41.png";